
const multiples = {
  days: 1000 * 60 * 60 * 24,
  hours: 1000 * 60 * 60,
  minutes: 1000 * 60,
  seconds: 1000
};

export function durationToString(value: string| number , full = false) {
  if(!value) return '0s';

  let rest = parseInt(value.toString());
  if(!rest) return '0s';

  const days = parseInt((rest / multiples.days).toString());
  rest -= days * multiples.days;

  const hours = parseInt((rest / multiples.hours).toString());
  rest -= hours * multiples.hours;

  const minutes = parseInt((rest / multiples.minutes).toString());
  rest -= minutes * multiples.minutes;

  const seconds = parseInt((rest / multiples.seconds).toString());

  let str = '';

  if (days > 0 || full) str += days + (days > 1 ? 'd ' : 'd ');
  if (hours > 0 || full) str += hours + (hours > 1 ? 'h ' : 'h ');
  if (days === 0 && minutes > 0 || full) str += minutes + (minutes > 1 ? 'm ' : 'm ');
  if ((days === 0 && hours === 0) || full) str += seconds + (seconds > 1 ? 's ' : 's ');
  
  return str;
}

export function calcAgo(value: string | Date, full = false) {
  if(!value) return '0s';

  const date = new Date(value.toString());
  const now = new Date();
  const milliseconds = now.getTime() - (new Date(date)).getTime();

  return durationToString(milliseconds, full);
}
